export class EnumUtils {
  static convertStringToEnum<T>(
    type: T,
    str: string,
  ): T[keyof T] | undefined {
    const casted = str.toUpperCase() as keyof T;
    return type[casted];
  }

  static getValueFromEnum<T>(
    value: string,
    enumType: T,
  ): T[keyof T] | undefined {
    const enumValues = Object.values(enumType);
    const enumKeys = Object.keys(enumType) as (keyof T)[];

    for (let i = 0; i < enumValues.length; i++) {
      if (enumValues[i] === value) {
        return enumType[enumKeys[i]];
      }
    }

    return undefined;
  }
}
